import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import DeportesView from './DeportesView';
import * as ROUTES from '../../../router/Routes';

const DeportesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.deportes} routes={[]}>
      <DeportesView />
    </ContainerTemplate>
  );
};

export default DeportesModule;
